import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

export const CustomDatePicker = ({ date, setDate, isDisabled }) => {

    const handleDateChange = (date) => {
        if (date != null) {
            setDate(date);
        }

    };

    // NOTE: react-datepicker's customInput clone overwrites `onChange` with its
    // own handler, so a manual-entry handler here was never called. The one
    // that used to live here also destructured [_, month, day, year] out of a
    // dd/mm/yyyy match - day and month the wrong way round - and passed the
    // 1-based month straight to new Date(y, m, d). Deleted rather than left as
    // a trap for whoever wires manual entry up properly.

    const formatDate = (date) => {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based 
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };
    return (
        <DatePicker
            showIcon
            selected={date}
            onChange={handleDateChange}
            customInput={
                <input
                    type="text"
                    placeholder="dd/mm/yyyy"
                    className="gf-date-input"
                />
            }
            showMonthDropdown
            showYearDropdown
            dateFormat="dd/MM/yyyy"
            disabled={isDisabled}
            // The sidebar is a 336px column that scrolls and clips, so left to
            // itself the calendar is positioned inside that column and cut off
            // at the edge. `strategy: 'fixed'` takes it out of the scrolling
            // context so it can overhang the map; react-datepicker sets
            // whileElementsMounted: autoUpdate, so it still tracks the input
            // as the sidebar scrolls.
            //
            // Do NOT add popperModifiers here. react-datepicker 7 moved from
            // popper.js to floating-ui, so that prop takes floating-ui
            // middleware objects, not popper's { name, options } descriptors -
            // passing the latter makes computePosition call `fn` on a plain
            // object, the promise rejects unhandled, and the calendar renders
            // pinned to the top-left of the window. It already applies
            // flip({ padding: 15 }) and offset(10) of its own accord.
            placeholderText="dd/mm/yyyy"
            popperClassName="gf-date-popper"
            popperPlacement="bottom-start"
            popperProps={{ strategy: 'fixed' }}
        />

    );
};

export function formatDate(date) {
    if (date === undefined) return "";
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based 
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
}